import { render, staticRenderFns } from "./CreateEmpty.vue?vue&type=template&id=3cd7ad2a&"
import script from "./CreateEmpty.vue?vue&type=script&lang=js&"
export * from "./CreateEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports